import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import {initialFilter} from "../../../../utils/UIHelpers";

const ResultManagerUserUIContext = createContext();

export function useResultManagerUserUIContext() {
  return useContext(ResultManagerUserUIContext);
}

export function ResultManagerUserUIProvider({ children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParams,
  };

  return (
    <ResultManagerUserUIContext.Provider value={value}>
      {children}
    </ResultManagerUserUIContext.Provider>
  );
}
